import React from 'react';
import { AdvertisedListItem } from '@/components/ads/advertised-list-item';
import {
  FlatList,
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  View,
} from 'react-native';
import { HorizontalListArrows } from '@/components/horizontal-list-arrows';
import { ItemListOption } from '@/contexts/item-context-types';

import { BRAND_PAGE_COLLECTION_SOURCE } from '@/utils/brand-page';
import { SCREEN_PADDING_SMALL, TYPOGRAPHY } from '@/styles';
import { useItemDetailContext } from '@/contexts/item-detail-context';
import { useLayoutContext } from '@/contexts/layout-context';
import { useNewOrderActionsContext } from '@/contexts/new-order-actions-context';

export interface BrandPageCollection {
  title: string;
  variantPacks: ItemListOption[];
}

interface Props {
  collection: BrandPageCollection;
  headerStyle?: StyleProp<TextStyle>;
}

export const BrandPageCollection: React.FC<Props> = ({
  collection,
  headerStyle,
}) => {
  const { selectItemListOption } = useItemDetailContext();
  const { debouncedUpdateQuantity } = useNewOrderActionsContext();
  const { isSmallLayout } = useLayoutContext();

  return (
    <View
      key={collection.title}
      style={styles.collectionWrapper}
      testID="brand-page-collection"
    >
      <Text style={[TYPOGRAPHY.h3, headerStyle]}>{collection.title}</Text>
      <HorizontalListArrows<ItemListOption>
        arrowShape="round"
        displayAsStatic
        staticArrowContainerStyle={
          !isSmallLayout ? styles.arrowContainer : null
        }
        trackingKey={BRAND_PAGE_COLLECTION_SOURCE}
      >
        {(listProps) => (
          <FlatList<ItemListOption>
            {...listProps}
            alwaysBounceHorizontal={false}
            contentContainerStyle={styles.collectionList}
            data={collection.variantPacks}
            horizontal
            renderItem={({ item }) => {
              return (
                <AdvertisedListItem
                  containerStyle={styles.collectionListItem}
                  item={item}
                  onSelect={() => {
                    selectItemListOption(item, {
                      source: BRAND_PAGE_COLLECTION_SOURCE,
                    });
                  }}
                  updateQuantity={(updateQuantityData) => {
                    debouncedUpdateQuantity(updateQuantityData, {
                      source: BRAND_PAGE_COLLECTION_SOURCE,
                    });
                  }}
                />
              );
            }}
            showsHorizontalScrollIndicator={false}
          />
        )}
      </HorizontalListArrows>
    </View>
  );
};

const styles = StyleSheet.create({
  arrowContainer: {
    paddingRight: 8,
    position: 'absolute',
    right: 0,
    top: 8,
  },
  collectionList: {
    paddingLeft: SCREEN_PADDING_SMALL,
  },
  collectionListItem: {
    marginVertical: 8,
  },
  collectionWrapper: {
    marginBottom: 32,
  },
});
